module.exports = __webpack_public_path__ + "static/media/sumo.d36c9abd.svg";